// src/components/donation/DonationHero.jsx
import { motion } from "framer-motion";
import donateIllustration from "../../assets/images/donation/donate-illustration.svg"; // Download from Storyset

const DonationHero = () => {
  return (
    <section className="bg-gradient-to-br from-blue-50 to-white py-20">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left: Illustration */}
        <motion.div
          className="flex justify-center"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={donateIllustration}
            alt="Support Impact Illustration"
            className="max-w-md w-full drop-shadow-lg"
          />
        </motion.div>

        {/* Right: Content */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9 }}
          className="text-left"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-primary mb-6 leading-tight">
            Support Our Mission to Drive Positive Social Change
          </h1>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed">
            Your contribution empowers us to amplify impact through collaborative programs, 
            inclusive initiatives, and sustainable solutions for communities in need.
          </p>

          <div className="mt-6">
            <a
              href="#donate-now"
              className="inline-block bg-secondary text-white px-6 py-3 rounded-full shadow hover:bg-primary transition duration-300"
            >
              Donate Now
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DonationHero;
